import gql from "graphql-tag";

const me = gql`
  query {
    me {
      id
      username
      email
      fullname
      department {
        id
        name
      }
      position {
        id
        name
      }
      departmentMangers {
        id
        name
      }
      employee {
        code
        email
        fullname
        birthday
        positionId
        departmentId
        userId
        gender
        concurrentPositions {
          id
        }
        position {
          id
          name
          status
        }
        department {
          id
          name
          status
        }
        user {
          id
          fullname
          username
          email
        }
        annualLeaveDay {
          id
          remain
          default
        }
        sickLeaveDay {
          id
          remain
          default
        }
        createdAt
        updatedAt
        author {
          id
          fullname
        }
      }
    }
  }
`;

export default { me };
